// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__1fHr_","input":"Input_input__3rPb3","label":"Input_label__3sEkI","error":"Input_error__HOCjV","noSpacing":"Input_noSpacing__1sLTc"};